import { IconButton } from "@material-ui/core";
import { CancelRounded } from "@material-ui/icons";
import React from "react";
import styled from "styled-components";

const SearchContainer = styled.div`
  display: flex;
  align-items: center;
  position: relative;
  width: 100%;
  
  .MuiIconButton-root {
    position: absolute;
    right: 5px;
    padding: 8px;
    color: #94a3b8;
    
    &:hover {
      color: #ef4444;
      background: rgba(239, 68, 68, 0.1);
    }
  }
`;

const SearchInput = styled.input`
  border: 1px solid #e2e8f0;
  outline: none;
  padding: 12px 18px;
  width: 100%;
  height: 3rem;
  font-size: 0.95rem;
  border-radius: 99px;
  background: #f8fafc;
  color: #334155;
  transition: all 0.2s ease;

  &::placeholder {
    color: #cbd5e1;
  }

  &:focus {
    background: white;
    border-color: #054752;
    box-shadow: 0 0 0 3px rgba(5, 71, 82, 0.1);
  }
`;

const SearchField = ({
  onChange,
  clearSearch,
  value,
  placeholder,
  style = {},
}) => {
  return (
    <SearchContainer>
      <SearchInput
        type="text"
        value={value}
        placeholder={placeholder}
        onChange={onChange}
        style={style}
      />
      {value && (
        <IconButton onClick={clearSearch}>
          <CancelRounded />
        </IconButton>
      )}
    </SearchContainer>
  );
};

export default SearchField;
